import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

/** Styling specific to the Billing card's "Renewal Info" hover panel; its layout comes from `OverviewHoverPanel`. */
export const renewalInfoPanelStyles = StyleSheet.create({
	stopCancellation: {
		alignSelf: 'flex-start',
		marginTop: THEME.spacing.sm,
	},
});
